<template>
  <div class="shell">
    <NuxtRouteAnnouncer />
    <header class="topbar">
      <nav class="container topbar-inner">
        <NuxtLink to="/legacy" class="brand">tools<span>.coreasia.id</span></NuxtLink>
        <div class="topbar-links">
          <NuxtLink to="/legacy/kompres-foto">Kompres Foto</NuxtLink>
          <NuxtLink to="/legacy/kompres-pdf">Kompres PDF</NuxtLink>
          <NuxtLink to="/legacy/berkaskilat">BerkasKilat</NuxtLink>
          <NuxtLink to="/legacy/rapikontak">RapiKontak</NuxtLink>
          <NuxtLink to="/legacy/redeem" class="btn btn-small">Tukar Kode</NuxtLink>
        </div>
      </nav>
    </header>
    <main class="container main">
      <slot />
    </main>
    <!--
      Isi footer dipindah ke komponen supaya identitas, kanal kontak, dan
      tautan kebijakan (wajib untuk situs yang menerima pembayaran) ikut
      terbawa saat tampilan diganti desain baru.
    -->
    <FooterGlobal />
  </div>
</template>
